// Small shared formatters (no moment.js dependency).

export function fmtDate(value) {
  if (!value) return '—'
  const d = new Date(value)
  if (isNaN(d.getTime())) return '—'
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: '2-digit' })
}

export function fmtDateTime(value) {
  if (!value) return '—'
  const d = new Date(value)
  if (isNaN(d.getTime())) return '—'
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

// Map a validation/report/suitability status to a `.pill-*` modifier class.
export function statusPill(status) {
  const s = (status || '').toLowerCase()
  if (['valid', 'ok', 'completed'].includes(s)) return 'pill-green'
  if (['invalid', 'error', 'failed'].includes(s)) return 'pill-red'
  if (['processing', 'pending'].includes(s)) return 'pill-amber'
  return 'pill-muted'
}
